/* istanbul ignore file */

import { FieldIdentifier } from './field-identifier';
import { FormulaMapping } from './logic-builder';

export class FormulaProperties {
    formulaMappings: FormulaMapping[];
    formulaOperands: FieldIdentifier[];
}
